export default {
  en: {
    title: 'Trend',
    tooltipCurrent: '{{percent}}%',
    noDataThisPoint: 'No practice at this point',
    insufficientMessage: "Keep practicing — the trend will show up once there's enough data",
  },
  ru: {
    title: 'Динамика',
    tooltipCurrent: '{{percent}}%',
    noDataThisPoint: 'В этой точке не занимался',
    insufficientMessage: 'Позанимайся ещё — динамика будет видна, как только наберётся достаточно данных',
  },
  de: {
    title: 'Trend',
    tooltipCurrent: '{{percent}}%',
    noDataThisPoint: 'Keine Übung an diesem Punkt',
    insufficientMessage: 'Übe weiter — der Trend erscheint, sobald genug Daten vorhanden sind',
  },
  pt: {
    title: 'Tendência',
    tooltipCurrent: '{{percent}}%',
    noDataThisPoint: 'Sem prática neste ponto',
    insufficientMessage: 'Continue praticando — a tendência vai aparecer quando houver dados suficientes',
  },
  fr: {
    title: 'Tendance',
    tooltipCurrent: '{{percent}}%',
    noDataThisPoint: 'Pas de pratique à ce point',
    insufficientMessage: 'Continue de t’entraîner — la tendance apparaîtra dès qu’il y aura assez de données',
  },
  es: {
    title: 'Tendencia',
    tooltipCurrent: '{{percent}}%',
    noDataThisPoint: 'Sin práctica en este punto',
    insufficientMessage: 'Sigue practicando — la tendencia aparecerá cuando haya suficientes datos',
  },
};
